






















































































































































import {Component, Watch, Vue, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import axios from 'axios'
import IArrow from '@/components/icons/IArrow.vue'
import IPencil from '@/components/icons/IPencil.vue'
import EditItem from '@/components/UI/EditItem.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Alert from '@/components/UI/Alert.vue';

const products = namespace('products')

@Component({
  components: {
    IArrow,
    IPencil,
    EditItem,
    BtnDefault,
    Alert,
  }
})

export default class SelctedProduct extends Vue {
  @products.Getter('product') protected product: any
  @products.Getter('loading') protected loading: any
  @products.Action('editProduct') protected editProduct: any

  panel: any = [0, 1, 2]
  newCharacteristic: any = {
    title: '',
    value: ''
  }
  isError: any = {
    character_title: false,
    character_value: false
  }

  addCharacteristic() {
    this.isError.character_title = this.newCharacteristic.title == ''
    this.isError.character_value = this.newCharacteristic.value == ''
    this.isError.character_title = this.newCharacteristic.title == ''
    this.isError.character_value = this.newCharacteristic.value == ''

    if (!this.isError.character_title && !this.isError.character_value) {
      this.product.characters.push(this.newCharacteristic)
      this.saveChange()
      this.newCharacteristic = {
        title: '',
        value: ''
      }
    }
  }

  deleteItem(item: any, field: string, index: string) {
    this.product.characters.splice(index, 1)
    this.saveChange()
  }

  saveChange() {
    this.editProduct({
      params: {
        productId: this.product._id
      },
      body: this.product
    })
  }

  saveChangeLink(item: any) {
    this.product.promo[0] = item
    this.editProduct({
      params: {
        productId: this.product._id
      },
      body: this.product
    })
  }
}
